exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vbt-autcomplete-list[data-v-a0e87de4]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0e87de4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue
// module id = 676
// module chunks = 0 1